import React, { useState, useEffect } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { getDownloadCentreListAPI } from "../../../api/api";

const DownloadList = () => {
  const [error, seterror] = useState({
    errarStatus: false,
    errorMessage: "",
    bgcolor: "",
  });

  const [downloadList, setdownloadList] = useState([]);

  const getDownloadList = () => {
    getDownloadCentreListAPI().then((res) => {
      if (res.data.success === true) {
        setdownloadList(res.data.data);
      } else {
        seterror({
          errarStatus: true,
          errorMessage: res.data.message,
          bgcolor: "alert alert-danger",
        });
      }
    });
  };

  useEffect(() => {
    getDownloadList();
  }, []);

  const download = (url) => {
    window.location.href = url;
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="row">
                <div className="col-lg-12 col-md-12 order-1">
                  {error.errarStatus ? (
                    <div className={error.bgcolor} role="alert">
                      <strong>Alert!</strong> {error.errorMessage}
                      <button
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  ) : null}

                  <div className="card">
                    <h5 className="card-header">Account Wise Summary</h5>
                    <div className="table-responsive text-nowrap">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>User Name</th>
                            <th>From Date</th>
                            <th>To Date</th>
                            <th>Created Date</th>
                            <th>Download Link</th>
                          </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                          {downloadList.map((items, i) => (
                            <tr key={i}>
                              <td>
                                <span className="text-primary">
                                  {items.user_id}
                                </span>
                              </td>
                              <td>{items.startdate}</td>
                              <td>{items.enddate}</td>
                              <td>{items.created_date}</td>
                              <td>
                                {items.linkfordownload ? (
                                  <button
                                    className="badge bg-info border-0"
                                    onClick={() =>
                                      download(
                                        `https://smppintl.datagenit.com/report/downloadcenter/${items.linkfordownload}`
                                      )
                                    }
                                  >
                                    <FontAwesomeIcon icon={faDownload} /> Click
                                    Here To Download
                                  </button>
                                ) : (
                                  <span className="badge bg-label-secondary">
                                    Please Wait
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadList;
